export default __webpack_public_path__ + "static/media/Sad2.60a15f50.png";